/* eslint-disable complexity */
import "./input-upload-file.scss";

import { Image } from "react-bootstrap";
import {
  AlertCircleIcon,
  DeleteIcon,
  FailureIcon,
  SuccessCircleIcon,
  UploadIcon,
} from "src/assets";
import { FileUploadedStatus, InputUploadFileProps } from "src/types";
import { Button, Modal } from "src/ui/widgets";

import { useInputUploadFile } from "./input-upload-file.hook";

const ACCEPTED_FILE_TYPES = ".xlsx";

export const InputUploadFile = (props: InputUploadFileProps) => {
  const {
    selectedFileName,
    width,
    height,
    showAlert = false,
    fileStatus,
  } = props;

  const {
    t,
    isShowAlert,
    fileStatusMessage,
    isOutOfSizeFile,
    inputUploadFileRef,
    handleDrop,
    confirmAction,
    toggleAlert,
    handleFileChange,
    setIsOutOfSizeFile,
  } = useInputUploadFile(props);

  const StatusUpload = (
    <div>
      <div
        className={`font-14-bold ${
          fileStatus === FileUploadedStatus.OK ? "success-box" : "errors-box"
        } `}
      >
        {fileStatusMessage && t(fileStatusMessage)}
        <Image
          src={
            fileStatus === FileUploadedStatus.OK
              ? SuccessCircleIcon
              : AlertCircleIcon
          }
          width={20}
          height={20}
          className={`ms-2 ms-md-3 ${
            fileStatus === FileUploadedStatus.OK ? "" : "filter-F34747"
          } `}
        />
      </div>
    </div>
  );

  const UploadBox = (
    <div
      className={`drag-drop${
        selectedFileName
          ? fileStatus === FileUploadedStatus.OK
            ? "--success"
            : "--error"
          : ""
      }`}
      style={{ width: width, height: height }}
    >
      <div
        className={`document-uploader ${
          selectedFileName ? "upload-box active" : "upload-box"
        } ${
          !fileStatus
            ? "border-neutral"
            : fileStatus === FileUploadedStatus.OK
            ? "border-ok"
            : "border-errors"
        }`}
        onDrop={handleDrop}
        onDragOver={(event) => event.preventDefault()}
      >
        <div className={`${selectedFileName ? "d-none" : "internal-box"}`}>
          <>
            <div className="text-center font-14">
              <div>{t("upload_file.title")}</div>
            </div>
            <input
              ref={inputUploadFileRef}
              type="file"
              hidden
              id="browse"
              onChange={handleFileChange}
              accept={ACCEPTED_FILE_TYPES}
            />
            <Image
              src={UploadIcon}
              width={100}
              height={100}
              className="filter-f5bb78 mt-3 mb-3"
            />
            <label
              htmlFor="browse"
              className="font-15-semibold text-underline browse-btn d-none d-md-block"
            >
              {t("upload_file.upload_label_computer")}
            </label>
            <label
              htmlFor="browse"
              className="font-15-semibold text-underline browse-btn d-block d-md-none"
            >
              {t("upload_file.upload_label_mobile")}
            </label>
          </>
        </div>

        {selectedFileName && StatusUpload}

        {selectedFileName && (
          <div className="file-list">
            <div className="file-item mt-3">
              <div className="font-15-semibold pe-2 pe-md-5 col-md-11 ">
                {selectedFileName}
              </div>
              <Image
                className={`delete-icon ${
                  fileStatus === FileUploadedStatus.OK
                    ? "filter-00686F"
                    : "filter-F34747"
                }`}
                src={DeleteIcon}
                width={20}
                height={20}
                onClick={() => toggleAlert()}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );

  const ModalErrorMaxSize = (
    <Modal
      visible={isOutOfSizeFile}
      onClose={() => setIsOutOfSizeFile(false)}
      classes="d-flex justify-content-center"
    >
      <div>
        <div className="d-flex align-items-center justify-content-center">
          <Image src={FailureIcon} width={64} height={64} />
        </div>
        <div className="m-3 font-14">{t("commons.max_exceeded")}</div>
      </div>
    </Modal>
  );

  const ModalShowAlert = (
    <Modal
      visible={true}
      onClose={() => {
        setIsOutOfSizeFile(false), toggleAlert();
      }}
      classes="d-flex justify-content-center"
    >
      <div>
        <div className="d-flex align-items-center justify-content-center">
          <Image
            src={FailureIcon}
            width={64}
            height={64}
            className="filter-F34747"
          />
        </div>
        <div className="m-3 font-14">
          {t("entry_group_step_2.alert_delete_file")}
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <Button
            text={t("commons.confirm")}
            flavor="accent"
            classes="primary d-flex justify-content-center button-submit m-md-0"
            classesText="font-15-semibold"
            classesIconRight="ms-2"
            onPress={() => confirmAction()}
          />
        </div>
      </div>
    </Modal>
  );

  return (
    <main id={`file-${name}`}>
      {UploadBox}
      <div>{ModalErrorMaxSize}</div>
      <div>{showAlert && isShowAlert && ModalShowAlert}</div>
    </main>
  );
};
